import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getCountSla = createAsyncThunk('/count_sla/content', async (nopage) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/companyCountSla`, {})
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            window.location.href = '/login';
        }
    }
})


export const countSlaSlice = createSlice({
    name: 'count_sla',
    initialState: {
        isLoading: false,
        count_sla: []
    },

    extraReducers: (builder) => {
        builder
            .addCase(getCountSla.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCountSla.fulfilled, (state, action) => {
                state.count_sla = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getCountSla.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export default countSlaSlice.reducer